module.exports = __webpack_public_path__ + "static/img/purple-pending.b04a6c64.png";